var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Clappr = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.getIsLive()) {
      return this.player.getCurrentTime() + this.player.getStartTimeOffset()
    }
    return this.player.getCurrentTime()
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return null
  },

  /** Override to return Frames Per Secon (FPS) */
  getFramesPerSecond: function () {
    return null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getDuration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return this.bitrate || -1
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    return this.rendition
  },

  /** Override to return title */
  getTitle: function () {
    return null
  },

  /** Override to return title2 */
  getTitle2: function () {
    return null
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.getContainer().getPlaybackType() == 'live'
  },

  /** Override to return resource URL. */
  getResource: function () {
    var src = this.getPlayback().options.sources
    return (typeof src == 'object') ? src.source : src
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.getPlayerName() + Clappr.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'clappr'
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    return null
  },

  /** Returns the container of the player */
  getContainer: function () {
    return this.player.core.getCurrentContainer()
  },

  /** Returns the playback of the player */
  getPlayback: function () {
    return this.player.core.getCurrentPlayback()
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(false, false)

    // Register listeners
    if (this.getPlayback()) {
      this.getPlayback().on(Clappr.Events.PLAYBACK_PLAY_INTENT, this.playIntentListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_PLAY, this.playListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_PAUSE, this.pauseListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_STOP, this.stopListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_ENDED, this.endedListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_ERROR, this.errorListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_BUFFERING, this.bufferingListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_BUFFERFULL, this.bufferFullListener.bind(this))
      this.getPlayback().on(Clappr.Events.PLAYBACK_BITRATE, this.bitrateListener.bind(this))
    }
    if (this.getContainer()) {
      this.getContainer().on(Clappr.Events.CONTAINER_SEEK, this.seekListener.bind(this))
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.getPlayback()) {
      this.getPlayback().off(Clappr.Events.PLAYBACK_PLAY_INTENT, this.playIntentListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_PLAY, this.playListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_PAUSE, this.pauseListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_STOP, this.stopListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_ENDED, this.endedListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_ERROR, this.errorListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_BUFFERING, this.bufferingListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_BUFFERFULL, this.bufferFullListener)
      this.getPlayback().off(Clappr.Events.PLAYBACK_BITRATE, this.bitrateListener)
    }
    if (this.getContainer()) {
      this.getContainer().off(Clappr.Events.CONTAINER_SEEK, this.seekListener)
    }
  },

  /** Listener for 'play intent' event. */
  playIntentListener: function () {
    this.fireStart()
    this.tag = this.getPlayback().video
  },

  /** Listener for 'play' event. */
  playListener: function () {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'pause' event. */
  pauseListener: function () {
    this.firePause()
  },

  /** Listener for 'stop' event. */
  stopListener: function () {
    this.fireStop()
  },

  /** Listener for 'ended' event. */
  endedListener: function () {
    this.fireStop()
  },

  /** Listener for 'error' event. */
  errorListener: function (error, player) {
    var errCode = error.code + '-' + player
    this.fireError(errCode)
  },

  /** Listener for 'buffering' event. */
  bufferingListener: function () {
    this.fireBufferBegin()
  },

  /** Listener for 'buffer full' event. */
  bufferFullListener: function () {
    this.fireBufferEnd()
    if (hasSeekEvent) {
      hasSeekEvent = false
      this.fireSeekEnd() // video end seeking
    }
  },

  /** Listener for 'bitrate' event. */
  bitrateListener: function (e) {
    this.bitrate = e.bitrate
    if (e.bandwidth && e.width && e.height) {
      this.rendition = Util.buildRenditionString(e.width, e.height, e.bandwidth)
    }
  },

  /** Listener for 'seek' event. */
  seekListener: function () {
    hasSeekEvent = true
    this.fireSeekBegin() // video starts seeking
  },
})

module.exports = youbora.adapters.Clappr



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 25
// module chunks = 0